module.exports = (__webpack_require__(8917))(24);